/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PlagiarismRunCourseParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
    ['virtual', codecBoolean],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class PlagiarismRunCourse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismRunCourseParser.decode(input).map(res => new PlagiarismRunCourse(res));
    }
    static unsafeDecode(input) {
        return PlagiarismRunCourse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismRunCourseParser.encode(data);
    }
    static schema() {
        return PlagiarismRunCourseParser.schema();
    }
}
